module.exports = __webpack_public_path__ + "static/media/resource-5@3x.9a492824.jpg";